const isNonEmptyString = (str: unknown) =>
    typeof str === 'string' && str.length > 0;

export default isNonEmptyString;
